import React, { Component } from 'react';
import {CSVExporter} from "../Common/CSVExporter";
import {formatDate, formatDateTime} from "../Utilities/DateTimeUtils";
import {getFullName} from "../Utilities/DebaterUtilities";

class AssignmentCSVExporter extends Component {

    constructor(props){
        super(props);
        this.state={
            filename: "",
            data: [],
            loading: true
        };
        this.roomsCSV = this.roomsCSV.bind(this);
        this.eventName = this.eventName.bind(this);
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        const data = this.roomsCSV(this.props.rooms);
        const eventName = formatDate(this.props.event.date) + " - " + this.props.event.event_type;
        const fileName = "Assignments " + eventName;
        this.setState({data: data, fileName: fileName, loading: false});
    }

    eventName(event) {
        return formatDateTime(this.state.event.time) + " " + this.state.event.event_type;
    }

    roomsCSV(rooms) {
        const header = ['Room Number', 'Room Name', 'Room Language',
                        'Opening Government', 'Opening Opposition', 'Closing Government', 'Closing Opposition',
                        'Chair', 'Panel'];
        const data=[header];
        let roomNumber = 0;
        for(const roomId in rooms) {
            roomNumber ++;
            let keepGoing = true;
            let i = 0;
            const room = rooms[roomId];
            while(keepGoing) {
                let row = [roomNumber.toString(), room['Name'], room['Language'],
                    i < room['Opening Government'].length ? getFullName(room['Opening Government'][i]):'',
                    i < room['Opening Opposition'].length ? getFullName(room['Opening Opposition'][i]):'',
                    i < room['Closing Government'].length ? getFullName(room['Closing Government'][i]):'',
                    i < room['Closing Opposition'].length ? getFullName(room['Closing Opposition'][i]):'',
                    i < room['Chair'].length ? getFullName(room['Chair'][i]):'',
                    i < room['Panel'].length ? getFullName(room['Panel'][i]):'',
                ];
                data.push(row);
                i++;
                keepGoing =
                    (i < room['Opening Government'].length ||
                    i < room['Opening Opposition'].length ||
                    i < room['Closing Government'].length ||
                    i < room['Closing Opposition'].length ||
                    i < room['Chair'].length ||
                    i < room['Panel'].length);
            }
        }
        return data;
    }

    render() {
        if(this.state.loading) return null;
        return (
            <CSVExporter
                fileName={this.state.fileName}
                data={this.state.data}/>
         );
    }
}

export default AssignmentCSVExporter;
